import { ObservableArray, View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerSideDataLoader } from "uicomponents";
import { SingleTransaction, TransactionListViewModel } from "./transactionList-viewModel"

export class TransactionListView extends View<TransactionListViewModel>{
    GetViewUniqueId(): string {
        return "V-67685E99-6750-4DE6-B620-E8AB232FD57D"
    }
    loadHtml(): string {
        let element = require('./transactionList.html').default;
        let style = require('./transactionList.less');
        return element;
    }
    constructor() {
       super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set transactions(v: ObservableArray<SingleTransaction>) { this._transactions = v; } public get transactions(): ObservableArray<SingleTransaction> { return this._transactions;} private _transactions: ObservableArray<SingleTransaction>;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;

    addNewTransaction(){
        this.dataContext.addNewTransaction();
    }

    export(){
        this.dataContext.export();
    }
}
